import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Checkbox from "@mui/material/Checkbox";
import Card from "react-bootstrap/Card";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FaStar } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import Cards from "../HOME/Card";
import { Pagination } from "@mui/material";

const style = {
  position: "absolute" as "absolute",
  top: "65.2%",
  borderRadius: "10px",
  left: "80.5%",
  transform: "translate(-50%, -50%)",
  width: 320,
  height: "400px",
  bgcolor: "background.paper",
  overflow: "hidden",
  boxShadow: 24,
  p: 4,
};

const stylemobile = {
  position: "absolute" as "absolute",
  top: "50%",
  borderRadius: "10px",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 360,
  bgcolor: "background.paper",
  overflow: "hidden",
  boxShadow: 24,
};


const data = [
  {
    title: "Samsung Galaxy A15 5G",
    specs: "(8Gb RAM , 128GB)",
    rating: "4.5",
    offPrice: "19,499.00",
    ogPrice: "19,500.00",
    discountpercent: "10",
  },
];

const Productlist = () => {
  const [open, setOpen] = useState(false);
  const [showSmartFilter, setShowSmartFilter] = useState(false);
  const [showTabsFilter, setShowTabsFilter] = useState(false);
  const [showCameraFilter, setShowCameraFilter] = useState(false);
  const [showMusicFilter, setShowMusicFilter] = useState(false);
  const [showAirFilter, setShowAirFilter] = useState(false);
  const [showCommercialFilter, setShowCommercialFilter] = useState(false);
  const [showMp3Filter, setShowMp3Filter] = useState(false);
  const [showDVDFilter, setShowDVDFilter] = useState(false);
  const [showPriceFilter, setshowPriceFilter] = useState(false);
  const [showColorFilter, setshowColorFilter] = useState(false);
  const [isSamsungChecked, setIsSamsungChecked] = useState(false);
  const [Categories, setCategories] = React.useState(false);
  const handleOpencategories = () => setCategories(true);
  const handleClosecategories = () => setCategories(false);
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [selectedBrand, setSelectedBrand] = useState<string | null>(null);

  const handleBrandChange = (brand: string) => {
    setSelectedBrand(brand === selectedBrand ? null : brand); 
  };

  const handleButtonClick = (buttonName: string) => {
    setActiveButton(buttonName);
  };

  const handleSamsungChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsSamsungChecked(event.target.checked);
  };

  const togglePriceFilter = () => {
    setshowPriceFilter(!showPriceFilter);
    setshowColorFilter(false);
  };

  const toggleColorFilter = () => {
    setshowColorFilter(!showColorFilter);
    setshowPriceFilter(false);
  };

  const toggleSmartFilter = () => {
    setShowSmartFilter(!showSmartFilter);
  };

  const toggleTabsFilter = () => {
    setShowTabsFilter(!showTabsFilter);
  };

  const toggleCameraFilter = () => {
    setShowCameraFilter(!showCameraFilter);
  };

  const toggleMusicFilter = () => {
    setShowMusicFilter(!showMusicFilter);
  };

  const toggleAirFilter = () => {
    setShowAirFilter(!showAirFilter);
  };

  const toggleCommercialFilter = () => {
    setShowCommercialFilter(!showCommercialFilter);
  };

  const toggleMp3Filter = () => {
    setShowMp3Filter(!showMp3Filter);
  };

  const toggleDVDFilter = () => {
    setShowDVDFilter(!showDVDFilter);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <section style={{ paddingTop: "6rem" }} className="pb-4">
        <Container>
          <div>
            <p className="title-para">Home - Product</p>
            <h2 className="title-navhead">Products</h2>
          </div>

          <div className="our-title-combine">
            <p className="p-txt">Our Products</p>
            <div onClick={handleOpen}>
              <button className="filter-btn-pl">
                All Filter &nbsp;&nbsp;&nbsp;
                <i className="fi fi-rr-bars-filter"></i>
              </button>
            </div>
          </div>

          {/* Show this div only in mobile view */}
          <div className="mobile-view d-block d-sm-none mt-3">
            <div className="d-flex justify-content-between">
              <div>
                <div className="mobile-btn-1" onClick={handleOpencategories}>
                  <div className="d-flex justify-content-between">
                    <div> Categories </div>
                    <div className="mt-1 ms-3">
                      <i className="fi fi-rr-angle-small-down down-mobile"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Button className="mobile-btn-2"  onClick={()=>setOpen(true)}
                >
                  <i className="fi fi-rr-settings-sliders icon-mobile"></i>
                </Button>
              </div>
            </div>
          </div>

          <div className="mt-2">
            <div className="row">
              <div className="col col-lg-4 col-md-4 col-sm-12 d-none d-sm-block">
                <div style={{width:"350px"}}>
                  <div className="d-flex">
                    <div>
                      <Checkbox color="default" />
                    </div>
                    <p className="filter-price-txt-1">All</p>
                  </div>

                  <hr />

                  <div>
                    {/* Smart */}
                    <div>
                      {/* Smart Filter Toggle */}
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleSmartFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">Smart</p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showSmartFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showSmartFilter && (
                        <div>
                          {/* Samsung Checkbox */}
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox
                                color="default"
                                size="small"
                                onChange={handleSamsungChange}
                              />
                            </div>
                            <p className="filter-price-txt">Samsung</p>
                          </div>

                          {isSamsungChecked && (
                            <div className="d-flex justify-content-start ms-4">
                              <div className="d-flex flex-column">
                                <div className="d-flex gap-1">
                                  <div>
                                    <Checkbox color="default" size="small" />
                                  </div>
                                  <p className="filter-price-txt">
                                    Galaxy A Series
                                  </p>
                                </div>
                                <div className="d-flex gap-1">
                                  <div>
                                    <Checkbox color="default" size="small" />
                                  </div>
                                  <p className="filter-price-txt">
                                    Galaxy F Series
                                  </p>
                                </div>
                                <div className="d-flex gap-1">
                                  <div>
                                    <Checkbox color="default" size="small" />
                                  </div>
                                  <p className="filter-price-txt">
                                    Galaxy J Series
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Other brands */}
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">iPhone</p>
                          </div>
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Vivo</p>
                          </div>
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Oppo</p>
                          </div>
                        </div>
                      )}
                    </div>

                    <hr />

                    {/* Tabs & Laptops */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleTabsFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">Tabs & Laptop</p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showTabsFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showTabsFilter && (
                        <div>
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Dell</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Hp</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Dell</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Hp</p>
                          </div>
                        </div>
                      )}
                    </div>
                    <hr />

                    {/* Camera */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleCameraFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">Camera</p>
                        </div>

                        {/* Toggle icon */}
                        <p onClick={toggleCameraFilter} className="p-txt-icon">
                          <i
                            className={`fi ${
                              showCameraFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showCameraFilter && (
                        <div>
                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Samsung</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Iphone</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Vivo</p>
                          </div>

                          <div className="d-flex gap-1">
                            <div>
                              <Checkbox color="default" size="small" />
                            </div>
                            <p className="filter-price-txt">Oppo</p>
                          </div>
                        </div>
                      )}
                    </div>

                    <hr />

                    {/* Music system */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleMusicFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">Music system</p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showMusicFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showMusicFilter && <div></div>}
                    </div>

                    <hr />

                    {/* Air Contioner */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleAirFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">Air Conditioner</p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showAirFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showAirFilter && <div></div>}
                    </div>
                    <hr />

                    {/* Commercial appliance  */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleCommercialFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">
                            Commercial appliance
                          </p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showCommercialFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showCommercialFilter && <div></div>}
                    </div>
                    <hr />

                    {/* MP3 Player */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleMp3Filter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">MP3 Player</p>
                        </div>

                        {/* Toggle icon */}
                        <p className="p-txt-icon">
                          <i
                            className={`fi ${
                              showMp3Filter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showMp3Filter && <div></div>}
                    </div>
                    <hr />

                    {/* DVD Player */}

                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={toggleDVDFilter}
                      >
                        <div className="d-flex">
                          <div>
                            <Checkbox color="default" />
                          </div>
                          <p className="filter-price-txt-2">DVD Player</p>
                        </div>

                        {/* Toggle icon */}
                        <p onClick={toggleDVDFilter} className="p-txt-icon">
                          <i
                            className={`fi ${
                              showDVDFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showDVDFilter && <div></div>}
                    </div>
                  </div>
                </div>
              </div>
              {/* <Cards /> */}
           
            </div>
            <div className="d-flex justify-content-end">
              <Pagination count={10} />
              </div>
          </div>
         

          {/* Laptop-view modal */}
          <div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div>
                  {/* Filter Header */}
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="p-txt-mt">Filter</p>
                    </div>
                    <p onClick={handleClose} className="p-txt">
                      <i className="fi fi-rr-cross-small clear"></i>
                    </p>
                  </div>

                  <div className="mt-3">
                    {/* Price Filter */}
                    <div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="p-txt-m">Price</p>
                        </div>
                        <p onClick={togglePriceFilter} className="p-txt">
                          <i
                            className={`fi ${
                              showPriceFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showPriceFilter && (
                        <div className="price-filter-section">
                          <div className="d-flex flex-column justify-content-center">
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">
                                10,000 - 20,000
                              </p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">
                                20,000 - 40,000
                              </p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">
                                40,000 - 60,000
                              </p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">
                                60,000 - 80,000
                              </p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">
                                80,000 - 1,00,000
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      <hr className="mt-2" />
                    </div>

                    {/* Discount Filter */}
                    <div className="mt-2">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="p-txt-m">Discount</p>
                        </div>
                        <p onClick={toggleColorFilter} className="p-txt">
                          <i
                            className={`fi ${
                              showColorFilter
                                ? "fi-rr-angle-small-up"
                                : "fi-rr-angle-small-down"
                            } clear`}
                          ></i>
                        </p>
                      </div>

                      {showColorFilter && (
                        <div className="price-filter-section">
                          <div className="d-flex flex-column justify-content-center">
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">Above 80%</p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">60% - 80% </p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">40% - 60%</p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">40% - 20%</p>
                            </div>
                            <div className="d-flex combine-modal">
                              <div>
                                <Checkbox size="small" color="default" />
                              </div>
                              <p className="filter-price-txt">Below 20%</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Fixed Clear and Apply Buttons */}
                    <div
                      className="d-flex justify-content-between align-items-end gap-3"
                      style={{
                        position: "fixed",
                        bottom: "5%",
                        backgroundColor: "white",
                        padding: "10px",
                      }}
                    >
                      <div>
                        <Button className="clear-btn">Clear all</Button>
                      </div>
                      <div>
                        <Button className="apply-btn">Apply</Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>
            </Modal>
          </div>

          {/* Mobile-view Categories modal */}

          <div>
            <Modal
              open={Categories}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={stylemobile}>
                <div className="d-flex justify-content-between p-2">
                  <div>
                    <p className="p-txt-mt">Categories</p>
                  </div>
                  <p onClick={handleClosecategories} className="p-txt">
                    <i className="fi fi-rr-cross-small clear"></i>
                  </p>
                </div>
                <div className="mobile-btn-combine p-2">
                  <div>
                    <Button
                      className={`btn-m-1 ${
                        activeButton === "Smart Phone" ? "active-btn" : ""
                      }`}
                      onClick={() => handleButtonClick("Smart Phone")}
                    >
                      Smart Phone
                    </Button>
                  </div>
                  <div>
                    <Button
                      className={`btn-m-1 ${
                        activeButton === "Tabs" ? "active-btn" : ""
                      }`}
                      onClick={() => handleButtonClick("Tabs")}
                    >
                      Tabs
                    </Button>
                  </div>
                  <div>
                    <Button
                      className={`btn-m-1 ${
                        activeButton === "Laptops" ? "active-btn" : ""
                      }`}
                      onClick={() => handleButtonClick("Laptops")}
                    >
                      Laptops
                    </Button>
                  </div>
                  <div>
                    <Button
                      className={`btn-m-1 ${
                        activeButton === "Watch" ? "active-btn" : ""
                      }`}
                      onClick={() => handleButtonClick("Watch")}
                    >
                      Watch
                    </Button>
                  </div>
                </div>

                <div className="row row-mobile">
                  {/* Column 1 - Brand Checkboxes */}
                  <div className="col col-sm-3 col-mobile">
                    <div className="d-flex mobile-box">
                      <div>
                        <Checkbox
                          color="default"
                          checked={selectedBrand === "Samsung"}
                          onChange={() => handleBrandChange("Samsung")}
                        />
                      </div>
                      <p className="filter-price-txt-1">Samsung</p>
                    </div>
                    <div className="mt-2">
                      <hr />
                    </div>
                    <div className="d-flex mobile-box">
                      <div>
                        <Checkbox
                          color="default"
                          checked={selectedBrand === "Iphone"}
                          onChange={() => handleBrandChange("Iphone")}
                        />
                      </div>
                      <p className="filter-price-txt-1">Iphone</p>
                    </div>
                    <div className="mt-2">
                      <hr />
                    </div>
                    <div className="d-flex mobile-box">
                      <div>
                        <Checkbox
                          color="default"
                          checked={selectedBrand === "Vivo"}
                          onChange={() => handleBrandChange("Vivo")}
                        />
                      </div>
                      <p className="filter-price-txt-1">Vivo</p>
                    </div>
                    <div className="mt-2">
                      <hr />
                    </div>
                    <div className="d-flex mobile-box">
                      <div>
                        <Checkbox
                          color="default"
                          checked={selectedBrand === "Oppo"}
                          onChange={() => handleBrandChange("Oppo")}
                        />
                      </div>
                      <p className="filter-price-txt-1">Oppo</p>
                    </div>
                    <div className="mt-2"></div>
                  </div>

                  {/* Column 2 - Mobile Variants */}
                  <div className="col col-sm-9">
                    <div className="mt-3">
                      {selectedBrand === "Samsung" && (
                        <>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">
                              Galaxy A Series
                            </p>
                          </div>

                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">
                              Galaxy F Series
                            </p>
                          </div>

                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">
                              Galaxy J Series
                            </p>
                          </div>
                        </>
                      )}

                      {selectedBrand === "Iphone" && (
                        <>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">iPhone 12</p>
                          </div>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">iPhone 13</p>
                          </div>
                        </>
                      )}

                      {selectedBrand === "Vivo" && (
                        <>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">Vivo X Series</p>
                          </div>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">Vivo Y Series</p>
                          </div>
                        </>
                      )}

                      {selectedBrand === "Oppo" && (
                        <>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">
                              Oppo Reno Series
                            </p>
                          </div>
                          <div className="d-flex mobile-box">
                            <div>
                              <Checkbox color="default" />
                            </div>
                            <p className="filter-price-txt-1">Oppo F Series</p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-3 d-flex p-2 justify-content-between">
                  <div>
                    <Button className="clear-btn">Clear all</Button>
                  </div>
                  <div>
                    <Button className="apply-btn">Apply</Button>
                  </div>
                </div>
              </Box>
            </Modal>
          </div>

        </Container>
      </section>
    </>
  );
};

export default Productlist;
